import './setup';

import { recordBootEvent } from '@affine/core/bootstrap/boot-trace';
import { Telemetry } from '@affine/core/components/telemetry';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app';

function mountApp() {
  recordBootEvent('react-mount-started');
  // oxlint-disable-next-line @typescript-eslint/no-non-null-assertion
  const root = document.getElementById('app')!;
  createRoot(root).render(
    <StrictMode>
      <Telemetry />
      <App />
    </StrictMode>
  );
  recordBootEvent('react-render-requested');
}

try {
  mountApp();
} catch (err) {
  console.error('Failed to bootstrap app', err);
}
